/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useEffect, useRef } from 'react';

/**
 * Hook to track when the dashboard becomes hidden/visible.
 * Returns a function that checks if the dashboard is currently hidden,
 * useful for preventing unwanted blur events when users switch tabs, apps, or minimize windows.
 */
export function useDashboardVisibility() {
  const isDashboardHidden = useRef(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      isDashboardHidden.current = document.hidden;
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return () => isDashboardHidden.current;
}
